var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    clipRule: "evenodd",
    d: "M0 .296V2.37h18V.296H0Zm7 12.445h4v-2.074H7v2.074Zm8-5.185H3V5.482h12v2.074Z"
  })));
};
export { SvgFilter as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC41NCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDAuMjk2Mzg3VjIuMzcwNDZIMThWMC4yOTYzODdIMFpNNyAxMi43NDA4SDExVjEwLjY2NjhIN1YxMi43NDA4Wk0xNSA3LjU1NTY1SDNWNS40ODE1N0gxNVY3LjU1NTY1WiIvPgo8L3N2Zz4K";